import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import {
    DefaultOptions,
    ArrivedDepartStatusModel,
    updateFormValues,
} from "./helper";
import ValidationMessage from "../../../../../components/new/validation-message";
import { useToast } from "../../../../../hooks/ToastContext";
import Label from "../../../../../components/new/inputs/Label";
import LoaderButton from "../../../../../components/new/inputs/LoaderButton";
import { userCompanyId } from "../../../../../utility/helpers";
import CompanySelect from "../../../../../components/CommonSelect/CompanySelect";
import CustomSelect from "../../../../../components/new/inputs/Select";
import { getTripRoutesByCompany } from "../../../../../services/trip-route.service";
import {
    getTripsByRoute,
    getCountersByTrip,
    updateStatus,
} from "../../../../../services/counter/arrivedDepartStatus.service";
import { getErrorMessage } from "../../../helpers/booking-helper";

export default function ArrivedDepartedModal({ visible, setVisible }) {
    const { toast } = useToast();
    const [loading, setLoading] = useState(false);

    const [formState, setFormState] = useState(
        structuredClone(ArrivedDepartStatusModel)
    );
    const [formOptions, setFormOptions] = useState(DefaultOptions);

    const [counters, setCounters] = useState([]);

    const updateFormState = (field, value) => {
        setFormState(updateFormValues(field, value, formState));
    };

    const loadDependency = async () => {
        try {
            const companyId = userCompanyId() ?? formState.company_id.value;
            if (companyId) {
                let allTripRoutes = await getTripRoutesByCompany(companyId);
                allTripRoutes = allTripRoutes ?? [];
                formOptions.routes = allTripRoutes?.map((item) => ({
                    label: item.title_en,
                    value: item.id,
                }));

                setFormOptions({ ...formOptions });
            }

            const tripRouteId = formState.trip_route_id.value;
            if (tripRouteId) {
                let trips = await getTripsByRoute(tripRouteId);
                trips = trips.data.data ?? [];
                formOptions.trips = trips?.map((item) => ({
                    label: item.label,
                    value: item.trip_id,
                }));

                setFormOptions({ ...formOptions });
            }
        } catch (e) {
            toast.error({ detail: getErrorMessage(e) });
        }
    };

    useEffect(() => {
        loadDependency();
    }, [formState.company_id.value, formState.trip_route_id.value]);

    const search = async () => {
        setLoading(true);
        try {
            const tripId = formState.trip_id.value;
            if (tripId) {
                let counters = await getCountersByTrip(tripId);
                counters = counters.data.data ?? [];
                if (counters.length < 1) {
                    toast.error({ detail: "No counters found" });
                    return;
                }
                setCounters(counters);
            } else {
                toast.error({ detail: "Plese select a trip" });
            }
        } catch (e) {
            toast.error({ detail: getErrorMessage(e) });
        }

        setLoading(false);
    };

    const updateArrivedDepartStatus = async (trip_id, counter_id, data) => {
        try {
            await updateStatus(trip_id, counter_id, data);
            await search();
        } catch (e) {
            toast.error({ detail: getErrorMessage(e) });
        }
    };

    return (
        <div className="card flex justify-content-center">
            <Dialog
                header="Arrived/Departed Status:"
                maximizable
                visible={visible}
                onHide={() => {
                    setVisible(false);
                    setFormState(structuredClone(ArrivedDepartStatusModel));
                    setCounters([]);
                }}
                style={{
                    width: "80vw",
                    height: "80vh",
                }}
            >
                <div className="w-full">
                    <div className="flex gap-4 items-start">
                        {!userCompanyId() && (
                            <div className="flex-1 flex flex-col gap-1">
                                <Label
                                    htmlFor="company"
                                    title="Company"
                                    required={true}
                                />
                                <div className="flex flex-col">
                                    <CompanySelect
                                        inputId="company"
                                        onChange={(option) =>
                                            updateFormState(
                                                "company_id",
                                                option
                                            )
                                        }
                                        value={
                                            formState.company_id.selectedOption
                                        }
                                    />
                                    {formState.company_id.hasError && (
                                        <ValidationMessage
                                            message={
                                                formState.company_id.message
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="flex-1 flex flex-col gap-1">
                            <Label
                                htmlFor="Route"
                                title="Route"
                                required={true}
                            />
                            <div className="flex flex-col">
                                <CustomSelect
                                    inputId="trip_route"
                                    options={formOptions.routes}
                                    onChange={(option) => {
                                        updateFormState(
                                            "trip_route_id",
                                            option
                                        );
                                    }}
                                    value={
                                        formState.trip_route_id.selectedOption
                                    }
                                />
                                {formState.trip_route_id.hasError && (
                                    <ValidationMessage
                                        message={
                                            formState.trip_route_id.message
                                        }
                                    />
                                )}
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1">
                            <Label
                                htmlFor="trip_id"
                                title="Trip No"
                                required={true}
                            />
                            <CustomSelect
                                inputId="trip_id"
                                options={formOptions.trips}
                                onChange={(option) => {
                                    updateFormState("trip_id", option);
                                }}
                                value={formState.trip_id.selectedOption}
                            />
                            {formState.trip_id.hasError && (
                                <ValidationMessage
                                    message={formState.trip_id.message}
                                />
                            )}
                        </div>
                        <div className="flex-1/2 flex flex-col gap-1">
                            <LoaderButton
                                type="button"
                                title="Search"
                                onClick={search}
                                loading={loading}
                                className="mt-6"
                            />
                        </div>
                    </div>

                    {counters && counters.length > 0 ? (
                        <div className="relative overflow-hidden shadow-md rounded-lg mt-6">
                            <table className="table-fixed w-full text-left">
                                <thead
                                    className="uppercase bg-[#6b7280] text-[#e5e7eb]"
                                    style={{
                                        backgroundColor: "#6b7280",
                                        color: "#e5e7eb",
                                    }}
                                >
                                    <tr>
                                        <td className="py-1 border text-center  p-4">
                                            Counters
                                        </td>
                                        <td
                                            className="py-1 border text-center  p-4"
                                            colSpan={2}
                                        >
                                            Actions
                                        </td>
                                    </tr>
                                </thead>
                                <tbody
                                    className="bg-white text-gray-500"
                                    style={{
                                        backgroundColor: "#FFFFFF",
                                        color: "#6b7280",
                                    }}
                                >
                                    {counters.map((counter, index) => (
                                        <tr key={index} className="py-5">
                                            <td className="py-5 border text-center  p-4">
                                                {counter.counter_title}
                                            </td>
                                            {index > 0 ? (
                                                <td
                                                    className="py-5 border text-center  p-4"
                                                    colSpan={
                                                        index ==
                                                        counters.length - 1
                                                            ? 2
                                                            : null
                                                    }
                                                >
                                                    {counter.arrived_time ===
                                                    null ? (
                                                        <button
                                                            className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
                                                            onClick={() =>
                                                                updateArrivedDepartStatus(
                                                                    counter.trip_id,
                                                                    counter.counter_id,
                                                                    {
                                                                        is_arrived: true,
                                                                    }
                                                                )
                                                            }
                                                        >
                                                            {index ==
                                                            counters.length - 1
                                                                ? "End of Trip"
                                                                : "Not Arrived"}
                                                        </button>
                                                    ) : (
                                                        <button
                                                            disabled
                                                            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"
                                                        >
                                                            Arrived
                                                        </button>
                                                    )}
                                                </td>
                                            ) : null}

                                            {index < counters.length - 1 ? (
                                                <td
                                                    className="py-5 border text-center  p-4"
                                                    colSpan={
                                                        index == 0 ? 2 : null
                                                    }
                                                >
                                                    {counter.departed_time ===
                                                    null ? (
                                                        <button
                                                            className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
                                                            onClick={() =>
                                                                updateArrivedDepartStatus(
                                                                    counter.trip_id,
                                                                    counter.counter_id,
                                                                    {
                                                                        is_departed: true,
                                                                    }
                                                                )
                                                            }
                                                        >
                                                            {index == 0
                                                                ? "Start of Trip"
                                                                : "Not Departed"}
                                                        </button>
                                                    ) : (
                                                        <button
                                                            disabled
                                                            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"
                                                        >
                                                            Departed
                                                        </button>
                                                    )}
                                                </td>
                                            ) : null}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : null}

                    {/* {counters && counters.length > 0 && (
                        <div>
                            {renderStartCounter(counters[0])}
                            {renderBoradingDroppingCounter(counters)}
                            {renderEndCounter(counters[counters.length - 1])}
                        </div>
                    )} */}
                </div>
            </Dialog>
        </div>
    );
}
